// extracted by mini-css-extract-plugin
export default {"forgot_pass_container":"auth_forgot_pass_container__g0fvg","reset_pass_conainer":"auth_reset_pass_conainer__pAVrT"};